/**
 * Flag assets in static/images/flags/.
 * Named files for WP category slugs; ISO2 files (xx.svg) for world markers.
 */

/** WP / display slug → local filename (when not simply `{iso2}.svg`) */
const NAMED_FLAG_FILES: Record<string, string> = {
  andorra: "andorra.svg",
  austria: "austria.svg",
  belgium: "belgium.svg",
  "czech-republic": "czech-republic.svg",
  denmark: "denmark.svg",
  england: "england.svg",
  france: "france.svg",
  germany: "germany.svg",
  greece: "greece.svg",
  ireland: "ireland.svg",
  italy: "italy.svg",
  netherlands: "netherlands.svg",
  poland: "poland.svg",
  portugal: "portugal.svg",
  scotland: "scotland.svg",
  slovakia: "slovakia.svg",
  slovenia: "slovenia.svg",
  spain: "spain.svg",
  sweden: "Sweden.svg",
  switzerland: "switzerland.svg",
  wales: "wales.svg",
  sk: "sk.svg",
};

/**
 * @returns public URL for the flag, or null if unknown
 */
export function resolveFlagSrc(
  slugOrIso: string | null | undefined,
  iso2?: string | null
): string | null {
  if (!slugOrIso && !iso2) return null;

  const slug = (slugOrIso || "").toLowerCase();
  if (slug && NAMED_FLAG_FILES[slug]) {
    return `/images/flags/${NAMED_FLAG_FILES[slug]}`;
  }

  const iso = (iso2 || slug).toLowerCase();
  // ISO 3166-1 alpha-2 only (UK nations use named files above)
  if (/^[a-z]{2}$/.test(iso)) {
    return `/images/flags/${iso}.svg`;
  }

  return null;
}

export function hasFlagAsset(
  slugOrIso: string | null | undefined,
  iso2?: string | null
): boolean {
  return resolveFlagSrc(slugOrIso, iso2) != null;
}
